export enum RegistrationStatus {
    Registered = 0,
    Cancelled = 1,
    CheckedIn = 2,
    PendingTicketAllocation = 3
}